import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';
import { APP_ID, APP_VERSION } from '../../../../utils/constants/index';

export const LEQ_save_le_details_API_CALL = createAsyncThunk(
  'LEQ_save_le_details_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    dispatch({ type: 'LEQ_save_le_details_API_CALL/pending', payload: {} });
    const {
      save_le_detailsAPIPayload,
      successFn = () => {},
      errorFn = () => {},
      finallyFn,
    } = payload;
    const { customerId, Authorization, customerRefNum, limitEnhanceDetails } =
      save_le_detailsAPIPayload;
    const { salaryEnhance, gotPromotion, jobSwitch, salary } =
      limitEnhanceDetails;
    SecureClient({
      isEncrypted: true,
      customerId: customerId,
      route: 'customerkyc/save_limit_enhance_details',
      payload: {
        customerRefNum,
        appId: APP_ID,
        appVersion: APP_VERSION,
        limitEnhanceDetails: {
          salaryEnhance,
          gotPromotion,
          jobSwitch,
          salary,
        },
      },
      otherPayloadDetailsPresent: true,
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const save_le_detailsRes = res;
        dispatch({
          type: 'LEQ_save_le_details_API_CALL/fulfilled',
          payload: save_le_detailsRes,
        });
        if (successFn) successFn(save_le_detailsRes);
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({
          type: 'LEQ_save_le_details_API_CALL/rejected',
          payload: err,
        });
        if (errorFn) errorFn(err);
      },
      finallyFn,
    });
  }
);

export const LEQ_save_le_details_API_CALL_extrareducer = {
  [LEQ_save_le_details_API_CALL.pending]: (state, action) => {
    state.save_le_detailsAPICall.isLoading = true;
  },
  [LEQ_save_le_details_API_CALL.fulfilled]: (state, action) => {
    state.save_le_detailsAPICall.isLoading = false;
    state.save_le_detailsAPICall.isSuccess = true;
    state.save_le_detailsAPICall.isError = false;
    state.save_le_detailsAPICall.response = action.payload;
  },
  [LEQ_save_le_details_API_CALL.rejected]: (state, action) => {
    state.save_le_detailsAPICall.isLoading = false;
    state.save_le_detailsAPICall.isSuccess = false;
    state.save_le_detailsAPICall.isError = true;
    state.save_le_detailsAPICall.response = action.payload;
  },
};
